import { render, staticRenderFns } from "./WelcomePopupV3.vue?vue&type=template&id=62bf5f12&scoped=true&"
import script from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
export * from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePopupV3.vue?vue&type=style&index=0&id=62bf5f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bf5f12",
  null
  
)

export default component.exports